export class AzureOptionalCapabilities {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "enableAzureFilesBackup",
            "baseName": "enableAzureFilesBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enableRestorePointConversion",
            "baseName": "enableRestorePointConversion",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enableAdeRestore",
            "baseName": "enableAdeRestore",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enableAdeBackup",
            "baseName": "enableAdeBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "enableSqlTdeCmkBackup",
            "baseName": "enableSqlTdeCmkBackup",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureOptionalCapabilities.attributeTypeMap;
    }
    constructor() {
    }
}
